module.exports = __webpack_public_path__ + "img/red_036.1de8f559.png";